module.exports = __webpack_public_path__ + "img/SK.5176a25c.svg";